import { Component, OnInit, AfterViewInit, ViewChild } from '@angular/core';
import { GeneralService } from 'src/app/services/general.service';
declare var $ : any;
@Component({
  selector: 'app-castelo-presentation',
  templateUrl: './castelo-presentation.component.html',
  styleUrls: ['./castelo-presentation.component.scss']
})
export class CasteloPresentationComponent implements OnInit,AfterViewInit  {

  constructor(private generalService : GeneralService) { }
  compte = 0;
  listeStyleAxeGroup = [];
  listeStyleAxe = [];
  listeStyleAxeFiltred = [];
  listeStyleAxeGroupIsLoadet : boolean= false;
  listeStyleAxeIsLoadet : boolean= false;
  listeImageIsLoadet : boolean= false;
  @ViewChild("frmListeStyle",{static : false}) frmListeStyle;
  indexStyleAxeGroup : number
  indexStyleAxe : number;
  listeImage = []
  listeImageFiltred = []
  imageDomainUpload = this.generalService.imageDomainUpload;
  textDropArea1 = "";
  textDropArea2 = "";
  textDropArea3 = "";
  textDropArea4 = "";
  ngOnInit(): void 
  {
    this.getListeStyleAxeGroup();
    this.getListeStyleAxe();
    this.getListeImage();
  }
  ngAfterViewInit()
  {
    this.addEventDrop()
  }
  
  setListeImageFiltred(item)
  {
     this.listeImageFiltred = item.StyleAxeDFile
  }
  showImageListe()
  {
    $("#btn-liste").removeClass("inactive")
    $("#btn-liste").addClass("active")
    $("#btn-grid").removeClass("active")
    $("#btn-grid").addClass("inactive")
    $("#liste-drop-area").hide()
    $("#liste-image-right").show()
  }
  showImageGrid()
  {
    $("#btn-grid").removeClass("inactive")
    $("#btn-grid").addClass("active")
    $("#btn-liste").removeClass("active")
    $("#btn-liste").addClass("inactive")
    
    $("#liste-drop-area").show()
    $("#liste-image-right").hide()
  }
  selectedTabChangeStyleAxeGroup(styleAxeGroup)
  {
  }
  getListeStyleAxeGroup()
  {
    this.generalService.httpGet("https://backend-kastelo.pmc.tn/api/recherche/tbdata?tablere=StyleAxeGroup").subscribe(data =>
    {
      this.listeStyleAxeGroup = data;
      this.listeStyleAxeGroupIsLoadet = true;
      this.genererListe()
    })
  }
  getListeStyleAxe()
  {
    this.generalService.httpGet("https://backend-kastelo.pmc.tn/api/recherche/tbdata?tablere=StyleAxe").subscribe(data =>
    {
      this.listeStyleAxe = data
      this.listeStyleAxeIsLoadet = true;
      this.genererListe()
    })
  }
  getListeImage()
  {
    this.generalService.httpGet("https://backend-kastelo.pmc.tn/api/recherche/tbdata?tablere=StyleAxeDFile&param=3").subscribe(data=>
    {
      this.listeImage = data;
      this.listeImageIsLoadet = true;
      this.genererListe()
    })
  }
  genererListe()
  {
    if(this.listeImageIsLoadet &&this.listeStyleAxeGroupIsLoadet && this.listeStyleAxeIsLoadet)
    {
      this.listeStyleAxe.forEach(styleAxe =>
      {
        styleAxe["StyleAxeDFile"] = this.listeImage.filter(image =>{return image.StyleAxe_Id == styleAxe.StyleAxe_Id})
      }); 
      this.listeStyleAxeGroup.forEach(styleAxeGroup =>
      {
        styleAxeGroup["listeStyleAxe"] = this.listeStyleAxe.filter(styleAxe =>{return styleAxe.StyleAxeGroup_Id == styleAxeGroup.StyleAxeGroup_Id})
        styleAxeGroup["StyleAxeDFile"] = this.listeImage.filter(image =>{return this.generalService.isEmpty(image.StyleAxe_Id) == image.StyleAxeGroup_Id == styleAxeGroup.StyleAxeGroup_Id })
      });     
    }

  }

  onstyleAxeGroupChecked()
  {
    var listeStyleAxeGroupChecked = this.listeStyleAxeGroup.filter(styleGroupe => {return styleGroupe.checked})
    this.listeStyleAxeFiltred =  this.listeStyleAxe.filter(findStyleAxe => 
    {
      return listeStyleAxeGroupChecked.filter(findStyleAxeGroup =>
      {
        return findStyleAxeGroup.StyleAxeGroup_Id == findStyleAxe.StyleAxeGroup_Id
      }).length > 0
    })
  }
  addEventDrop()
  {
    for(var i=0;i<12;i++)
    {
      var dropArea = $("#drop-area-"+i)
      dropArea.on('dragenter', function (e)
      {
        e.preventDefault();
      });
    
      dropArea.on('dragover', function (e)
      {
        e.preventDefault();
      });
    
      dropArea.on('drop', (event)=>
      {
        event.preventDefault();
        var div = this.parseHTML(event.originalEvent.dataTransfer.getData('text/html'));
        var img = div.firstElementChild;
        if(img.id && img.id.indexOf("owner_img") >=0)
          this.createImage(event,img,div,event.currentTarget.id.split("-")[2])
        else 
          if(this.listeStyleAxeGroupIsLoadet && this.listeStyleAxeIsLoadet)
          {
            fetch(img["src"]).then((response) => 
            {
                    return response.blob();
            }).then(blob => 
            {
              this.imageBlob = blob;
              this.generalService.dialog.open(this.frmListeStyle);
            });
            
          }
          else
            this.generalService.dialogSuccess("Veuillez patienter pendant le chargement total des données",false);
      });       
    }
   
  }
  imageBlob;
  createImageBtn(div,event)
  {
    var imgBtn = new Image()
    imgBtn.src = "../../../assets/delete.jpg" ;
    imgBtn.id += "img-btn-del-" + this.compte;
      
    div.append(imgBtn);
    imgBtn.setAttribute("style","top: " + (event.offsetY+10) + "px; display: none; left: " +( event.offsetX+10) + "px; position: absolute; z-index: 2; width: 20px; cursor: pointer;border-radius: 8px;opacity: 0.8;") 
    imgBtn.addEventListener("click",()=>
    {
      $("#"+imgBtn.id).parent().remove()
    })
    imgBtn.addEventListener("mouseenter",()=>
    {
      imgBtn.style.opacity = "1";
      imgBtn.style.width = "21px";
    })
    imgBtn.addEventListener("mouseleave",()=>
    {
      imgBtn.style.opacity = "0.8";
      imgBtn.style.width = "20px";
    })
    div.addEventListener("mouseleave",()=>
    {
      $("#"+imgBtn.id).hide()
    })
    div.addEventListener("mouseenter",()=>
    {
      $("#"+imgBtn.id).show("fast")
    })
  }
  createImage(event,image,div,index)
  {
    image.id += "img_" + this.compte;
    image.setAttribute("style","position: absolute;top: " + event.offsetY + "px; left: " + event.offsetX + "px;")
    image.setAttribute("class","");
    this.createImageBtn(div,event)
    document.getElementById("drop-area-"+index).append(div);  
    
    setTimeout(()=>
    {    
  
      // $("#" + image.id).css("width",(50))
      // $("#" + image.id).css("height",(50))
      $("#" + image.id).resizable
      ({
        handles: 'se',
        aspectRatio: image.clientWidth / image.clientHeight
      });
      $("#" + div.id).draggable();  
      // $("#" + div.id).css("top","100px")
      // $("#" + div.id).css("left","100px") 
      
    },150)
    this.compte ++;
  }
  parseHTML(html)
  {
    var t = document.createElement('div');
    t.id = "div_" +this.compte;
    t.innerHTML = html;
    return t;
  }
  saveImage()
  {
    this.generalService.uploadFile2(this.imageBlob,"abc").subscribe(data =>
    {
      this.generalService.dialogSuccess("terminé",true)
    })
  }
}
